var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',[_c('v-icon',{style:(_vm.themeInverted),on:{"click":function($event){return _vm.decrement()}}},[_vm._v("mdi-minus")]),_c('label',{staticClass:"mx-1"},[_vm._v(_vm._s(_vm.qty))]),_c('v-icon',{staticClass:"mx-1",style:(_vm.themeInverted),on:{"click":function($event){return _vm.increment()}}},[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }